/** @jsxImportSource @emotion/react */

import React from 'react'
import { css } from '@emotion/react'
import { View, Button, ErrorText } from '@components/atoms'

import {
	useAppSelector,
	useAppDispatch,
	paymentActions,
	PaymentDeliveryType,
	PaymentStateType,
} from '@redux/index'

export const CardPaymentButton = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()
	const delivery: PaymentDeliveryType = useAppSelector(
		state => state.payment.paymentDelivery,
	)
	const errorMessages: PaymentStateType['paymentErrorMessages'] = useAppSelector(
		state => state.payment.paymentErrorMessages,
	)

	const isKrwPayment: boolean = React.useMemo(
		() => delivery.countryIsoCode === 'KR',
		[delivery],
	)

	const onPay = () => {
		if (isKrwPayment) {
			// 원화 결제
			reduxDispatch(paymentActions.TRIGGER_KRW_PAY_NOW(true))
		} else {
			// 달러 결제
			reduxDispatch(paymentActions.TRIGGER_USD_PAY_NOW(true))
		}
	}

	return (
		<View css={style}>
			<Button className="submitButton" variant="contained" size="large" onClick={onPay}>
				Pay Now
			</Button>
			<View className="submitErrorTextView">
				{!errorMessages.isSuccess && isKrwPayment ? (
					<ErrorText>
						필수 항목에 빠진 부분이 없는지 확인하시고 잘못 기입된 부분을 수정해주세요.
					</ErrorText>
				) : !errorMessages.isSuccess ? (
					<ErrorText>
						Some required fields may be missing, or certain inputs may be in an incorrect
						format.
					</ErrorText>
				) : (
					<></>
				)}
			</View>
		</View>
	)
}

const style = css({
	width: 'fit-content',
	minWidth: '30rem',
	float: 'right',
	textAlign: 'right',

	'.submitButton': {
		width: '20rem',
		height: '4rem',
	},

	'.submitErrorTextView': {
		width: '20rem',
		marginLeft: '10rem',
		textAlign: 'left',
		wordBreak: 'keep-all',
	},

	'@media (max-width: 600px)': {
		minWidth: '0px',
		width: 'calc(100vw - 4rem)',
		float: 'none',
		padding: '0 1rem 0 1.5rem',
		textAlign: 'left',

		'.submitButton': {
			width: '100%',
		},

		'.submitErrorTextView': {
			width: '100%',
			marginLeft: 0,
		},
	},
})
